import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo 2.4",
  "description": "Experimental Boundaries, Terminal UI improvements, experimental Watch Mode caching, and more.",
  "date": "2025/1/31",
  "tag": "web development"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 2.4 includes a number of improvements to enhance your repository:"
  }, {
    "heading": "",
    "content": "Boundaries Experimental: A first look at Boundaries in Turborepo"
  }, {
    "heading": "",
    "content": "Terminal UI improvements: Persistent preferences and new features"
  }, {
    "heading": "",
    "content": "Watch Mode caching Experimental: Develop faster in Watch Mode"
  }, {
    "heading": "",
    "content": "Circular dependency recommendations: Adopt Turborepo in large repos more easily"
  }, {
    "heading": "",
    "content": "schema.json in node_modules: Versioned configuration validation from within your repository"
  }, {
    "heading": "",
    "content": "ESLint Flat Config support: eslint-config-turbo and eslint-plugin-turbo updated for ESLint v9"
  }, {
    "heading": "",
    "content": "Upgrade today by running npx @turbo/codemod migrate or get started with npx create-turbo@latest."
  }, {
    "heading": "boundaries-experimental",
    "content": "Turborepo is built on top of package manager Workspaces, leaning on ecosystem conventions as a part of determining your repository's task caching. However, this requires that all developers in the repository know and adhere to those conventions."
  }, {
    "heading": "boundaries-experimental",
    "content": "We're introducing Boundaries, an experimental feature to catch places in the repository where these best practices aren't being followed. This makes caching safer, and ensures your repository is prepared to use future Turborepo features safely."
  }, {
    "heading": "boundaries-experimental",
    "content": "Try it today using:"
  }, {
    "heading": "boundaries-experimental",
    "content": "This early iteration of Boundaries includes finding two types of monorepo mistakes:"
  }, {
    "heading": "boundaries-experimental",
    "content": "Importing a file outside of the package's directory"
  }, {
    "heading": "boundaries-experimental",
    "content": "Importing a package that is not specified in dependencies"
  }, {
    "heading": "boundaries-experimental",
    "content": "We look forward to hearing your feedback on the Boundaries\nRFC, which includes\nproposals for these built-in diagnostics as well as custom-built Boundaries."
  }, {
    "heading": "boundaries-experimental",
    "content": "To learn more, visit the documentation."
  }, {
    "heading": "terminal-ui-improvements",
    "content": "We've continued iterating on the terminal UI, originally released in Turborepo 2.0."
  }, {
    "heading": "persistent-preferences",
    "content": "In previous versions of Turborepo, you would need to reset the terminal UI to your desired state every time you would run turbo. In Turborepo 2.4, we'll persist several of the UI selections that you've made, including:"
  }, {
    "heading": "persistent-preferences",
    "content": "The task that you had previously selected will be pre-selected the next time you run turbo. Give your up and down arrow keys a rest."
  }, {
    "heading": "persistent-preferences",
    "content": "Task list visibility, as described below"
  }, {
    "heading": "persistent-preferences",
    "content": "Task selection pinning, as described below"
  }, {
    "heading": "persistent-preferences",
    "content": "Together, persisting these preferences creates a more seamless experience across turbo invocations, restoring the UI to the state from the previous run of turbo."
  }, {
    "heading": "new-keybinds",
    "content": "We've added more functionality to the terminal UI to make it easier to work with your tasks and logs."
  }, {
    "heading": "new-keybinds",
    "content": "h to toggle task list: You're often focused on one of your tasks, so you don't need to see your task list, all the time. Press the h key to show and hide the task list. This feature is a persistent preference, as described above."
  }, {
    "heading": "new-keybinds",
    "content": "c to copy logs: Once you've highlighted a set of logs with your mouse, press c to copy the logs to your system clipboard."
  }, {
    "heading": "new-keybinds",
    "content": "j and k to select tasks: You can now use j and k in addition to ↑ and ↓ to cycle through the task list. Vim users rejoice."
  }, {
    "heading": "new-keybinds",
    "content": "p to pin the selected task: Selecting a task sets a \"pin\", meaning it will continue to be selected as your tasks change states. You can release the pin (or pin the task you're hovering) by pressing p. This feature is a persistent preference, as described above."
  }, {
    "heading": "new-keybinds",
    "content": "u and d to scroll logs: You can now press u to scroll your logs up and d to scroll your logs down."
  }, {
    "heading": "new-keybinds",
    "content": "m to learn more: Pressing m will show a popup listing all of the available keybinds."
  }, {
    "heading": "new-keybinds",
    "content": "Visit the documentation to learn more."
  }, {
    "heading": "watch-mode-caching-experimental",
    "content": "Watch Mode is a monorepo-aware watcher that re-runs tasks according to your Task Graph. This opens up brand new ways to work in monorepos by leveraging a single, global, dependency-aware watcher, rather than many smaller, less powerful watcher scripts."
  }, {
    "heading": "watch-mode-caching-experimental",
    "content": "In this release, we're adding caching as an experimental feature in Watch Mode. To activate it, use the --experimental-write-cache flag:"
  }, {
    "heading": "watch-mode-caching-experimental",
    "content": "To learn more about Watch Mode, visit the documentation."
  }, {
    "heading": "circular-dependency-recommendations",
    "content": "Circular dependencies are loops in your package graph that create non-deterministic cycles in Turborepo's Task Graph. However, if there is a loop in your task graph, Turborepo is unable to determine which task comes before which, since they both depend on each other."
  }, {
    "heading": "circular-dependency-recommendations",
    "content": "While adopting Turborepo in your monorepo, you may find circular dependencies as Turborepo create a more sophisticated, faster Task Graph than your previous task runner. Previously, Turborepo would naively list all of the packages involved in the cycle or cycles that exist in the repository's Package Graph. Now, Turborepo will include the dependency relationships that need to be broken up to get rid of the cycles in your graph."
  }, {
    "heading": "circular-dependency-recommendations",
    "content": "Compare the before and after of the terminal printouts below:"
  }, {
    "heading": "schemajson-in-node_modules",
    "content": "A schema.json file provides auto-complete and validation in your editor for JSON files. We have a web-accessible version of the schema.json for turbo.json hosted at https://turborepo.com/schema.json, but some developers prefer to get the file from node_modules to stay synced with the installed version of turbo."
  }, {
    "heading": "schemajson-in-node_modules",
    "content": "Starting in this release, schema.json is available in node_modules once you've run your package manager's install command:"
  }, {
    "heading": "schemajson-in-node_modules",
    "content": "We recommend installing turbo at the root of your repository, so the path\nfor the schema should point to node_modules at the root of your repository.\nIn Package Configurations, you may\nneed to use a path like ../../node_modules/turbo/schema.json."
  }, {
    "heading": "schemajson-in-node_modules",
    "content": "Visit the documentation for more information."
  }, {
    "heading": "eslint-flat-config-support",
    "content": "Turborepo 2.4 introduces support for ESLint v9 in eslint-config-turbo and eslint-plugin-turbo, following the end-of life for ESLint v8 on October 5, 2024."
  }, {
    "heading": "eslint-flat-config-support",
    "content": "The configuration and plugin remain backward compatible for those still using ESLint v8 to ensure a smooth transition."
  }, {
    "heading": "eslint-flat-config-support",
    "content": "For more information, visit the documentation."
  }, {
    "heading": "other-changes",
    "content": "feat(link): add --yes and --scope flags to link\n(#9466)"
  }, {
    "heading": "other-changes",
    "content": "feat(prune): add --use-gitignore flag (#9797)"
  }, {
    "heading": "other-changes",
    "content": "feat: remote cache upload timeout (#9491)"
  }, {
    "heading": "other-changes",
    "content": "feat: update eslint-config-turbo to support ESLint Flat Config. (#9502)"
  }, {
    "heading": "other-changes",
    "content": "feat: respect gitignore during turbo prune (#9711)"
  }, {
    "heading": "other-changes",
    "content": "fix(windows): fix env var glob casing (#9429)"
  }, {
    "heading": "other-changes",
    "content": "fix(cache): allow force to override any cache settings (#9454)"
  }, {
    "heading": "other-changes",
    "content": "fix(cache): no longer let remoteCache.enable override force (#9684)"
  }, {
    "heading": "other-changes",
    "content": "fix(cache): suggest proper --cache flag for --remote-cache-read-only (#9701)"
  }, {
    "heading": "other-changes",
    "content": "fix(cache): avoid warning if TURBO_FORCE, TURBO_REMOTE_ONLY, and TURBO_CACHE (#9704)"
  }, {
    "heading": "other-changes",
    "content": "fix(affected): consider both source and destination as changed (#9422)"
  }, {
    "heading": "other-changes",
    "content": "fix(env): add DISPLAY to default pass through (#9511)"
  }, {
    "heading": "other-changes",
    "content": "fix(env): allow passThroughEnv to negate built ins and globalPassThroughEnv (#9680)"
  }, {
    "heading": "other-changes",
    "content": "fix(cli): error on out of place run args (#9445)"
  }, {
    "heading": "other-changes",
    "content": "fix(daemon): limit number of git children (#9572)"
  }, {
    "heading": "other-changes",
    "content": "fix(examples): create-turbo dependencies with npm (#9580)"
  }, {
    "heading": "other-changes",
    "content": "fix(examples): add missing ESLint dependency (#9640)"
  }, {
    "heading": "other-changes",
    "content": "fix(examples): basic generator (#9687)"
  }, {
    "heading": "other-changes",
    "content": "fix(examples): bug in design system example (#9284)"
  }, {
    "heading": "other-changes",
    "content": "fix(example): remove conflict css property from with-tailwind example (#9816)"
  }, {
    "heading": "other-changes",
    "content": "fix(berry): add yarn berry support for built dependencies meta when pruning (#9605)"
  }, {
    "heading": "other-changes",
    "content": "fix(watch): watch command require tasks argument (#9598)"
  }, {
    "heading": "other-changes",
    "content": "fix(watch): fix output text when no tasks are provided (#9612)"
  }, {
    "heading": "other-changes",
    "content": "fix(watch): correctly derive opts from watch mode args (#9761)"
  }, {
    "heading": "other-changes",
    "content": "fix(package-manager): allow custom URL for packageManager version (#9624)"
  }, {
    "heading": "other-changes",
    "content": "fix(repository): honour handleTransparentWorkspaces setting in Yarn/Berry (#9626)"
  }, {
    "heading": "other-changes",
    "content": "fix(prune): fix Yarn1 entries getting merged erroneously (#9627)"
  }, {
    "heading": "other-changes",
    "content": "fix(create-turbo): correct repo name (#9708)"
  }, {
    "heading": "other-changes",
    "content": "fix(tui): avoid zombie process on clipboard write failure (#9713)"
  }, {
    "heading": "other-changes",
    "content": "fix(filewatcher): handle removed directories #8800 (#9406)"
  }, {
    "heading": "other-changes",
    "content": "fix: correct TUI vim binds direction (#9529)"
  }, {
    "heading": "other-changes",
    "content": "fix: packages listed twice in watch mode (#9644)"
  }, {
    "heading": "other-changes",
    "content": "fix: respect output mode 'none' even when caching is disabled (#9670)"
  }, {
    "heading": "other-changes",
    "content": "fix: upgrade the turbo package in Yarn 4 (#8076)"
  }, {
    "heading": "other-changes",
    "content": "docs: changesets configuration (#9325)"
  }, {
    "heading": "other-changes",
    "content": "docs: clarify output globs relativeness. (#9449)"
  }, {
    "heading": "other-changes",
    "content": "docs: add TURBO_CACHE to System Environment Variables. (#9450)"
  }, {
    "heading": "other-changes",
    "content": "docs(turbopack): Add incremental-computation page, intended to replace core-concepts page (#9456)"
  }, {
    "heading": "other-changes",
    "content": "docs(turbopack): Remove old core-concepts page (#9457)"
  }, {
    "heading": "other-changes",
    "content": "docs: small stylistic change for footnote. (#9451)"
  }, {
    "heading": "other-changes",
    "content": "docs: improve clarity on --cache. (#9489)"
  }, {
    "heading": "other-changes",
    "content": "docs: mark --no-cache and --remote-only as deprecated. (#9488)"
  }, {
    "heading": "other-changes",
    "content": "docs: describe using a custom URL with create-turbo. (#9507)"
  }, {
    "heading": "other-changes",
    "content": "docs: fix formatting on /docs/getting-started/installation (#9509)"
  }, {
    "heading": "other-changes",
    "content": "docs: fix formatting on /docs/getting-started/installation (#9514)"
  }, {
    "heading": "other-changes",
    "content": "docs: update ESLint documentation with ESLint v9 (#9515)"
  }, {
    "heading": "other-changes",
    "content": "docs: options one-pager (#9533)"
  }, {
    "heading": "other-changes",
    "content": "docs(typo): fix typo on turbo-ignore page (#9576)"
  }, {
    "heading": "other-changes",
    "content": "docs: clarify default daemon usage (#9566)"
  }, {
    "heading": "other-changes",
    "content": "docs: provide reasoning on why Turborepo doesn't support nested workspaces (#9586)"
  }, {
    "heading": "other-changes",
    "content": "docs: update CONTRIBUTING.md (#9590)"
  }, {
    "heading": "other-changes",
    "content": "docs: change path of options overview page (#9600)"
  }, {
    "heading": "other-changes",
    "content": "docs: remove old options page (#9601)"
  }, {
    "heading": "other-changes",
    "content": "docs: add community implementations of Remote Cache (#9631)"
  }, {
    "heading": "other-changes",
    "content": "docs: fix CONTRIBUTING.md typo (#9637)"
  }, {
    "heading": "other-changes",
    "content": "docs: mention capnp in the dependencies (#9643)"
  }, {
    "heading": "other-changes",
    "content": "docs: add missing api folder in turbo prune api --docker example (#9648)"
  }, {
    "heading": "other-changes",
    "content": "docs: add missing apps folder in prune command reference (#9658)"
  }, {
    "heading": "other-changes",
    "content": "docs: correct Bun support status (#9664)"
  }, {
    "heading": "other-changes",
    "content": "docs: mention module resolution differences for package managers (#9665)"
  }, {
    "heading": "other-changes",
    "content": "docs(errors): improve error message for recursive calls (#9650)"
  }, {
    "heading": "other-changes",
    "content": "docs: guide for Playwright (#9662)"
  }, {
    "heading": "other-changes",
    "content": "docs: mention --graph on graphs page (#9661)"
  }, {
    "heading": "other-changes",
    "content": "docs: document creating packages with framework bindings (#9222)"
  }, {
    "heading": "other-changes",
    "content": "docs: add note about packaging patterns (#9673)"
  }, {
    "heading": "other-changes",
    "content": "docs: guide for shadcn/ui (#9675)"
  }, {
    "heading": "other-changes",
    "content": "docs: add link to shadcn/ui page (#9678)"
  }, {
    "heading": "other-changes",
    "content": "docs: mention free remote caching earlier on page (#9688)"
  }, {
    "heading": "other-changes",
    "content": "docs: typo fix (#9690)"
  }, {
    "heading": "other-changes",
    "content": "docs(fix): correct line highlighting by removing extra comma (#9696)"
  }, {
    "heading": "other-changes",
    "content": "docs: add community-built Run Summaries web viewer (#9679)"
  }, {
    "heading": "other-changes",
    "content": "docs: edits for Prisma guide (#9682)"
  }, {
    "heading": "other-changes",
    "content": "docs: update docs to use correct changeset dir (#9722)"
  }, {
    "heading": "other-changes",
    "content": "docs: update CONTRIBUTING.md (#9759)"
  }, {
    "heading": "other-changes",
    "content": "docs: migration guide for users coming from Nx (#9762)"
  }, {
    "heading": "other-changes",
    "content": "docs: fix typo (#9814)"
  }, {
    "heading": "acknowledgments-and-community",
    "content": "Turborepo is the result of the combined work of all of its contributors, including our core team: Anthony, Chris, Dimitri, Nicholas, and Tom."
  }, {
    "heading": "acknowledgments-and-community",
    "content": "Thank you for your continued support, feedback, and collaboration to make Turborepo your build tool of choice. To learn how to get involved, visit the Community page."
  }, {
    "heading": "acknowledgments-and-community",
    "content": "We also thank everyone who contributed to this release of Turborepo: @aaronccasanova, @AlvaroParker, @ankur-arch, @arosequist, @atimmer, @bgw, @bitttttten, @chaficnajjar, @codexshell, @eps1lon, @gianelli99, @glitched-w0rld, @JasonnnW3000, @jbrocksfellas, @jeremy-code, @jonathandsouza, @Juneezee, @kayumuzzaman, @krlvi, @maciej-ka, @ognevny, @olets, @pkerschbaum, @romanofski, @shivam-pawar, @takaebato, @tevem1207, @thebrubaker, @Tofandel, @trivikr, @yamz8, and @zsh77."
  }],
  "headings": [{
    "id": "boundaries-experimental",
    "content": "Boundaries Experimental"
  }, {
    "id": "terminal-ui-improvements",
    "content": "Terminal UI improvements"
  }, {
    "id": "persistent-preferences",
    "content": "Persistent preferences"
  }, {
    "id": "new-keybinds",
    "content": "New keybinds"
  }, {
    "id": "watch-mode-caching-experimental",
    "content": "Watch Mode caching Experimental"
  }, {
    "id": "circular-dependency-recommendations",
    "content": "Circular dependency recommendations"
  }, {
    "id": "schemajson-in-node_modules",
    "content": "schema.json in node_modules"
  }, {
    "id": "eslint-flat-config-support",
    "content": "ESLint Flat Config support"
  }, {
    "id": "other-changes",
    "content": "Other changes"
  }, {
    "id": "acknowledgments-and-community",
    "content": "Acknowledgments and community"
  }]
};
import {Authors} from '#components/authors';
import {Date} from '#components/blog/date';
import {Tab, Tabs} from '#components/tabs';
import {Accordions, Accordion} from '#components/accordion';
import {ExperimentalBadge} from '#components/experimental-badge';
import {Kbd} from '#components/kbd';
import {Callout} from '#components/callout';
export const toc = [{
  depth: 2,
  url: "#boundaries-experimental",
  title: _jsxs(_Fragment, {
    children: ["Boundaries ", _jsx(ExperimentalBadge, {
      children: "Experimental"
    })]
  })
}, {
  depth: 2,
  url: "#terminal-ui-improvements",
  title: _jsx(_Fragment, {
    children: "Terminal UI improvements"
  })
}, {
  depth: 3,
  url: "#persistent-preferences",
  title: _jsx(_Fragment, {
    children: "Persistent preferences"
  })
}, {
  depth: 3,
  url: "#new-keybinds",
  title: _jsx(_Fragment, {
    children: "New keybinds"
  })
}, {
  depth: 2,
  url: "#watch-mode-caching-experimental",
  title: _jsxs(_Fragment, {
    children: ["Watch Mode caching ", _jsx(ExperimentalBadge, {
      children: "Experimental"
    })]
  })
}, {
  depth: 2,
  url: "#circular-dependency-recommendations",
  title: _jsx(_Fragment, {
    children: "Circular dependency recommendations"
  })
}, {
  depth: 2,
  url: "#schemajson-in-node_modules",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "schema.json"
    }), " in ", _jsx("code", {
      children: "node_modules"
    })]
  })
}, {
  depth: 2,
  url: "#eslint-flat-config-support",
  title: _jsx(_Fragment, {
    children: "ESLint Flat Config support"
  })
}, {
  depth: 2,
  url: "#other-changes",
  title: _jsx(_Fragment, {
    children: "Other changes"
  })
}, {
  depth: 2,
  url: "#acknowledgments-and-community",
  title: _jsx(_Fragment, {
    children: "Acknowledgments and community"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Turborepo 2.4"
    }), "\n", "\n", _jsx(Date, {
      children: "Friday, January 31st, 2025"
    }), "\n", _jsx(Authors, {
      authors: ['nicholasyang', 'anthonyshew', 'chrisolszewski']
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 2.4 includes a number of improvements to enhance your repository:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#boundaries-experimental",
          children: _jsxs(_components.strong, {
            children: ["Boundaries ", _jsx(ExperimentalBadge, {
              children: "Experimental"
            })]
          })
        }), ": A first look at Boundaries in Turborepo"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#terminal-ui-improvements",
          children: _jsx(_components.strong, {
            children: "Terminal UI improvements"
          })
        }), ": Persistent preferences and new features"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#watch-mode-caching-experimental",
          children: _jsxs(_components.strong, {
            children: ["Watch Mode caching ", _jsx(ExperimentalBadge, {
              children: "Experimental"
            })]
          })
        }), ": Develop faster in Watch Mode"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#circular-dependency-recommendations",
          children: _jsx(_components.strong, {
            children: "Circular dependency recommendations"
          })
        }), ": Adopt Turborepo in large repos more easily"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#schemajson-in-node_modules",
          children: _jsxs(_components.strong, {
            children: [_jsx(_components.code, {
              children: "schema.json"
            }), " in ", _jsx(_components.code, {
              children: "node_modules"
            })]
          })
        }), ": Versioned configuration validation from within your repository"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#eslint-flat-config-support",
          children: _jsx(_components.strong, {
            children: "ESLint Flat Config support"
          })
        }), ": ", _jsx(_components.code, {
          children: "eslint-config-turbo"
        }), " and ", _jsx(_components.code, {
          children: "eslint-plugin-turbo"
        }), " updated for ESLint v9"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Upgrade today by running ", _jsx(_components.code, {
        children: "npx @turbo/codemod migrate"
      }), " or get started with ", _jsx(_components.code, {
        children: "npx create-turbo@latest"
      }), "."]
    }), "\n", _jsxs(_components.h2, {
      id: "boundaries-experimental",
      children: ["Boundaries ", _jsx(ExperimentalBadge, {
        children: "Experimental"
      })]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo is built on top of package manager Workspaces, leaning on ecosystem conventions as a part of determining your repository's task caching. However, this requires that all developers in the repository know and adhere to those conventions."
    }), "\n", _jsx(_components.p, {
      children: "We're introducing Boundaries, an experimental feature to catch places in the repository where these best practices aren't being followed. This makes caching safer, and ensures your repository is prepared to use future Turborepo features safely."
    }), "\n", _jsx(_components.p, {
      children: "Try it today using:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " boundaries"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "This early iteration of Boundaries includes finding two types of monorepo mistakes:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Importing a file outside of the package's directory"
      }), "\n", _jsx(_components.li, {
        children: "Importing a package that is not specified in dependencies"
      }), "\n"]
    }), "\n", _jsx(Callout, {
      type: "info",
      title: "Boundaries RFC",
      children: _jsxs(_components.p, {
        children: ["We look forward to hearing your feedback on ", _jsx(_components.a, {
          href: "https://github.com/vercel/turborepo/discussions/9435",
          children: "the Boundaries\nRFC"
        }), ", which includes\nproposals for these built-in diagnostics as well as custom-built Boundaries."]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["To learn more, ", _jsx(_components.a, {
        href: "/docs/reference/boundaries",
        children: "visit the documentation"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "terminal-ui-improvements",
      children: "Terminal UI improvements"
    }), "\n", _jsxs(_components.p, {
      children: ["We've continued iterating on the terminal UI, originally released in ", _jsx(_components.a, {
        href: "/blog/turbo-2-0",
        children: "Turborepo 2.0"
      }), "."]
    }), "\n", _jsx(_components.h3, {
      id: "persistent-preferences",
      children: "Persistent preferences"
    }), "\n", _jsxs(_components.p, {
      children: ["In previous versions of Turborepo, you would need to reset the terminal UI to your desired state every time you would run ", _jsx(_components.code, {
        children: "turbo"
      }), ". In Turborepo 2.4, we'll persist several of the UI selections that you've made, including:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["The task that you had previously selected will be pre-selected the next time you run ", _jsx(_components.code, {
          children: "turbo"
        }), ". Give your up and down arrow keys a rest."]
      }), "\n", _jsx(_components.li, {
        children: "Task list visibility, as described below"
      }), "\n", _jsx(_components.li, {
        children: "Task selection pinning, as described below"
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Together, persisting these preferences creates a more seamless experience across ", _jsx(_components.code, {
        children: "turbo"
      }), " invocations, restoring the UI to the state from the previous run of ", _jsx(_components.code, {
        children: "turbo"
      }), "."]
    }), "\n", _jsx(_components.h3, {
      id: "new-keybinds",
      children: "New keybinds"
    }), "\n", _jsx(_components.p, {
      children: "We've added more functionality to the terminal UI to make it easier to work with your tasks and logs."
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsxs(_components.strong, {
          children: [_jsx(Kbd, {
            children: "h"
          }), " to toggle task list"]
        }), ": You're often focused on one of your tasks, so you don't need to see your task list, all the time. Press the ", _jsx(Kbd, {
          children: "h"
        }), " key to show and hide the task list. This feature is a persistent preference, as described above."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsxs(_components.strong, {
          children: [_jsx(Kbd, {
            children: "c"
          }), " to copy logs"]
        }), ": Once you've highlighted a set of logs with your mouse, press ", _jsx(Kbd, {
          children: "c"
        }), " to copy the logs to your system clipboard."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsxs(_components.strong, {
          children: [_jsx(Kbd, {
            children: "j"
          }), " and ", _jsx(Kbd, {
            children: "k"
          }), " to select tasks"]
        }), ": You can now use ", _jsx(Kbd, {
          children: "j"
        }), " and ", _jsx(Kbd, {
          children: "k"
        }), " in addition to ", _jsx(Kbd, {
          children: "↑"
        }), " and ", _jsx(Kbd, {
          children: "↓"
        }), " to cycle through the task list. Vim users rejoice."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsxs(_components.strong, {
          children: [_jsx(Kbd, {
            children: "p"
          }), " to pin the selected task"]
        }), ": Selecting a task sets a \"pin\", meaning it will continue to be selected as your tasks change states. You can release the pin (or pin the task you're hovering) by pressing ", _jsx(Kbd, {
          children: "p"
        }), ". This feature is a persistent preference, as described above."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsxs(_components.strong, {
          children: [_jsx(Kbd, {
            children: "u"
          }), " and ", _jsx(Kbd, {
            children: "d"
          }), " to scroll logs"]
        }), ": You can now press ", _jsx(Kbd, {
          children: "u"
        }), " to scroll your logs up and ", _jsx(Kbd, {
          children: "d"
        }), " to scroll your logs down."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsxs(_components.strong, {
          children: [_jsx(Kbd, {
            children: "m"
          }), " to learn more"]
        }), ": Pressing ", _jsx(Kbd, {
          children: "m"
        }), " will show a popup listing all of the available keybinds."]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.a, {
        href: "/docs/crafting-your-repository/developing-applications",
        children: "Visit the documentation to learn more."
      })
    }), "\n", _jsxs(_components.h2, {
      id: "watch-mode-caching-experimental",
      children: ["Watch Mode caching ", _jsx(ExperimentalBadge, {
        children: "Experimental"
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/crafting-your-repository/developing-applications#watch-mode",
        children: "Watch Mode"
      }), " is a monorepo-aware watcher that re-runs tasks according to your ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#task-graph",
        children: "Task Graph"
      }), ". This opens up brand new ways to work in monorepos by leveraging a single, global, dependency-aware watcher, rather than many smaller, less powerful watcher scripts."]
    }), "\n", _jsxs(_components.p, {
      children: ["In this release, we're adding caching as an experimental feature in Watch Mode. To activate it, use the ", _jsx(_components.code, {
        children: "--experimental-write-cache"
      }), " flag:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " watch"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " dev"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --experimental-write-cache"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["To learn more about Watch Mode, ", _jsx(_components.a, {
        href: "/docs/reference/watch",
        children: "visit the documentation"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "circular-dependency-recommendations",
      children: "Circular dependency recommendations"
    }), "\n", _jsxs(_components.p, {
      children: ["Circular dependencies are loops in your package graph that create non-deterministic cycles in Turborepo's ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#task-graph",
        children: "Task Graph"
      }), ". However, if there is a loop in your task graph, Turborepo is unable to determine which task comes before which, since they both depend on each other."]
    }), "\n", _jsxs(_components.p, {
      children: ["While adopting Turborepo in your monorepo, you may find circular dependencies as Turborepo create a more sophisticated, faster Task Graph than your previous task runner. Previously, Turborepo would naively list all of the packages involved in the cycle or cycles that exist in the repository's ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#package-graph",
        children: "Package Graph"
      }), ". Now, Turborepo will include the dependency relationships that need to be broken up to get rid of the cycles in your graph."]
    }), "\n", _jsx(_components.p, {
      children: "Compare the before and after of the terminal printouts below:"
    }), "\n", _jsxs(Tabs, {
      items: ["After", "Before"],
      children: [_jsx(Tab, {
        value: "After",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  children: "  × Invalid package dependency graph:"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  children: "  ╰─▶ Cyclic dependency detected:"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  children: "  │     @repo/logger, blog, storefront, @repo/ui"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  children: "  │     The cycle can be broken by removing any of these sets of dependencies:"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  children: "  │     { @repo/ui -> @repo/logger, @repo/ui -> storefront }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  children: "  │     { @repo/logger -> @repo/ui, @repo/ui -> storefront }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  children: "  │"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  children: "  ╰─▶   api, admin"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  children: "        The cycle can be broken by removing any of these sets of dependencies:"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  children: "        { admin -> api }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  children: "        { api -> admin }"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "Before",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  children: "  × Invalid package dependency graph: Cyclic dependency detected:"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  children: "  │     @repo/logger, storefront, @repo/ui, blog"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  children: "  │     api, admin"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  children: "  ╰─▶ Cyclic dependency detected:"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  children: "        @repo/logger, storefront, @repo/ui, blog"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  children: "        api, admin"
                })
              })]
            })
          })
        })
      })]
    }), "\n", _jsxs(_components.h2, {
      id: "schemajson-in-node_modules",
      children: [_jsx(_components.code, {
        children: "schema.json"
      }), " in ", _jsx(_components.code, {
        children: "node_modules"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["A ", _jsx(_components.code, {
        children: "schema.json"
      }), " file provides auto-complete and validation in your editor for JSON files. We have a web-accessible version of the ", _jsx(_components.code, {
        children: "schema.json"
      }), " for ", _jsx(_components.code, {
        children: "turbo.json"
      }), " hosted at ", _jsx(_components.a, {
        href: "https://turborepo.com/schema.json",
        children: _jsx(_components.code, {
          children: "https://turborepo.com/schema.json"
        })
      }), ", but some developers prefer to get the file from ", _jsx(_components.code, {
        children: "node_modules"
      }), " to stay synced with the installed version of ", _jsx(_components.code, {
        children: "turbo"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Starting in this release, ", _jsx(_components.code, {
        children: "schema.json"
      }), " is available in ", _jsx(_components.code, {
        children: "node_modules"
      }), " once you've run your package manager's install command:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"$schema\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"./node_modules/turbo/schema.json\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(Callout, {
      title: "node_modules location",
      children: _jsxs(_components.p, {
        children: ["We recommend installing ", _jsx(_components.code, {
          children: "turbo"
        }), " at the root of your repository, so the path\nfor the schema should point to ", _jsx(_components.code, {
          children: "node_modules"
        }), " at the root of your repository.\nIn ", _jsx(_components.a, {
          href: "/docs/reference/package-configurations",
          children: "Package Configurations"
        }), ", you may\nneed to use a path like ", _jsx(_components.code, {
          children: "../../node_modules/turbo/schema.json"
        }), "."]
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/getting-started/editor-integration#sourcing-from-node_modules",
        children: "Visit the documentation"
      }), " for more information."]
    }), "\n", _jsx(_components.h2, {
      id: "eslint-flat-config-support",
      children: "ESLint Flat Config support"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 2.4 introduces support for ESLint v9 in ", _jsx(_components.code, {
        children: "eslint-config-turbo"
      }), " and ", _jsx(_components.code, {
        children: "eslint-plugin-turbo"
      }), ", following the end-of life for ESLint v8 on October 5, 2024."]
    }), "\n", _jsxs(Tabs, {
      items: ["eslint-config-turbo", "eslint-plugin-turbo"],
      children: [_jsx(Tab, {
        value: "eslint-config-turbo",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./packages/eslint-config/index.js",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M1.125 0C.502 0 0 .502 0 1.125v21.75C0 23.498.502 24 1.125 24h21.75c.623 0 1.125-.502 1.125-1.125V1.125C24 .502 23.498 0 22.875 0zm17.363 9.75c.612 0 1.154.037 1.627.111a6.38 6.38 0 0 1 1.306.34v2.458a3.95 3.95 0 0 0-.643-.361 5.093 5.093 0 0 0-.717-.26 5.453 5.453 0 0 0-1.426-.2c-.3 0-.573.028-.819.086a2.1 2.1 0 0 0-.623.242c-.17.104-.3.229-.393.374a.888.888 0 0 0-.14.49c0 .196.053.373.156.529.104.156.252.304.443.444s.423.276.696.41c.273.135.582.274.926.416.47.197.892.407 1.266.628.374.222.695.473.963.753.268.279.472.598.614.957.142.359.214.776.214 1.253 0 .657-.125 1.21-.373 1.656a3.033 3.033 0 0 1-1.012 1.085 4.38 4.38 0 0 1-1.487.596c-.566.12-1.163.18-1.79.18a9.916 9.916 0 0 1-1.84-.164 5.544 5.544 0 0 1-1.512-.493v-2.63a5.033 5.033 0 0 0 3.237 1.2c.333 0 .624-.03.872-.09.249-.06.456-.144.623-.25.166-.108.29-.234.373-.38a1.023 1.023 0 0 0-.074-1.089 2.12 2.12 0 0 0-.537-.5 5.597 5.597 0 0 0-.807-.444 27.72 27.72 0 0 0-1.007-.436c-.918-.383-1.602-.852-2.053-1.405-.45-.553-.676-1.222-.676-2.005 0-.614.123-1.141.369-1.582.246-.441.58-.804 1.004-1.089a4.494 4.494 0 0 1 1.47-.629 7.536 7.536 0 0 1 1.77-.201zm-15.113.188h9.563v2.166H9.506v9.646H6.789v-9.646H3.375z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "import"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " turboConfig "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "from"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " 'eslint-config-turbo/flat'"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: ";"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: " "
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "export"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: " default"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  ..."
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "turboConfig"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-comment)",
                    "--shiki-dark": "var(--shiki-token-comment)"
                  },
                  children: "  // Other configuration"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "];"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "eslint-plugin-turbo",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./packages/eslint-config/index.js",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M1.125 0C.502 0 0 .502 0 1.125v21.75C0 23.498.502 24 1.125 24h21.75c.623 0 1.125-.502 1.125-1.125V1.125C24 .502 23.498 0 22.875 0zm17.363 9.75c.612 0 1.154.037 1.627.111a6.38 6.38 0 0 1 1.306.34v2.458a3.95 3.95 0 0 0-.643-.361 5.093 5.093 0 0 0-.717-.26 5.453 5.453 0 0 0-1.426-.2c-.3 0-.573.028-.819.086a2.1 2.1 0 0 0-.623.242c-.17.104-.3.229-.393.374a.888.888 0 0 0-.14.49c0 .196.053.373.156.529.104.156.252.304.443.444s.423.276.696.41c.273.135.582.274.926.416.47.197.892.407 1.266.628.374.222.695.473.963.753.268.279.472.598.614.957.142.359.214.776.214 1.253 0 .657-.125 1.21-.373 1.656a3.033 3.033 0 0 1-1.012 1.085 4.38 4.38 0 0 1-1.487.596c-.566.12-1.163.18-1.79.18a9.916 9.916 0 0 1-1.84-.164 5.544 5.544 0 0 1-1.512-.493v-2.63a5.033 5.033 0 0 0 3.237 1.2c.333 0 .624-.03.872-.09.249-.06.456-.144.623-.25.166-.108.29-.234.373-.38a1.023 1.023 0 0 0-.074-1.089 2.12 2.12 0 0 0-.537-.5 5.597 5.597 0 0 0-.807-.444 27.72 27.72 0 0 0-1.007-.436c-.918-.383-1.602-.852-2.053-1.405-.45-.553-.676-1.222-.676-2.005 0-.614.123-1.141.369-1.582.246-.441.58-.804 1.004-1.089a4.494 4.494 0 0 1 1.47-.629 7.536 7.536 0 0 1 1.77-.201zm-15.113.188h9.563v2.166H9.506v9.646H6.789v-9.646H3.375z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "import"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " turbo "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "from"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " 'eslint-plugin-turbo'"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: ";"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: " "
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "export"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: " default"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  {"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    plugins"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    rules"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "      'turbo/no-undeclared-env-vars'"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " 'error'"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-comment)",
                    "--shiki-dark": "var(--shiki-token-comment)"
                  },
                  children: "  // Other configuration"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "];"
                })
              })]
            })
          })
        })
      })]
    }), "\n", _jsx(_components.p, {
      children: "The configuration and plugin remain backward compatible for those still using ESLint v8 to ensure a smooth transition."
    }), "\n", _jsxs(_components.p, {
      children: ["For more information, ", _jsx(_components.a, {
        href: "/docs/reference/eslint-config-turbo",
        children: "visit the documentation"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "other-changes",
      children: "Other changes"
    }), "\n", _jsxs(Accordions, {
      children: [_jsx(Accordion, {
        title: "Features (5)",
        children: _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["feat(link): add ", _jsx(_components.code, {
              children: "--yes"
            }), " and ", _jsx(_components.code, {
              children: "--scope"
            }), " flags to ", _jsx(_components.code, {
              children: "link"
            }), "\n(", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9466",
              children: "#9466"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(prune): add ", _jsx(_components.code, {
              children: "--use-gitignore"
            }), " flag (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9797",
              children: "#9797"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat: remote cache upload timeout (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9491",
              children: "#9491"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat: update ", _jsx(_components.code, {
              children: "eslint-config-turbo"
            }), " to support ESLint Flat Config. (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9502",
              children: "#9502"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat: respect gitignore during turbo prune (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9711",
              children: "#9711"
            }), ")"]
          }), "\n"]
        })
      }), _jsx(Accordion, {
        title: "Fixes (29)",
        children: _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["fix(windows): fix env var glob casing (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9429",
              children: "#9429"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(cache): allow force to override any cache settings (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9454",
              children: "#9454"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(cache): no longer let remoteCache.enable override force (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9684",
              children: "#9684"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(cache): suggest proper --cache flag for --remote-cache-read-only (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9701",
              children: "#9701"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(cache): avoid warning if TURBO_FORCE, TURBO_REMOTE_ONLY, and TURBO_CACHE (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9704",
              children: "#9704"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(affected): consider both source and destination as changed (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9422",
              children: "#9422"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(env): add DISPLAY to default pass through (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9511",
              children: "#9511"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(env): allow ", _jsx(_components.code, {
              children: "passThroughEnv"
            }), " to negate built ins and ", _jsx(_components.code, {
              children: "globalPassThroughEnv"
            }), " (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9680",
              children: "#9680"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(cli): error on out of place run args (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9445",
              children: "#9445"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(daemon): limit number of git children (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9572",
              children: "#9572"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(examples): create-turbo dependencies with npm (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9580",
              children: "#9580"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(examples): add missing ESLint dependency (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9640",
              children: "#9640"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(examples): basic generator (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9687",
              children: "#9687"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(examples): bug in design system example (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9284",
              children: "#9284"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(example): remove conflict css property from with-tailwind example (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9816",
              children: "#9816"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(berry): add yarn berry support for built dependencies meta when pruning (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9605",
              children: "#9605"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(watch): watch command require tasks argument (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9598",
              children: "#9598"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(watch): fix output text when no tasks are provided (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9612",
              children: "#9612"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(watch): correctly derive opts from watch mode args (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9761",
              children: "#9761"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(package-manager): allow custom URL for ", _jsx(_components.code, {
              children: "packageManager"
            }), " version (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9624",
              children: "#9624"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(repository): honour handleTransparentWorkspaces setting in Yarn/Berry (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9626",
              children: "#9626"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(prune): fix Yarn1 entries getting merged erroneously (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9627",
              children: "#9627"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(create-turbo): correct repo name (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9708",
              children: "#9708"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(tui): avoid zombie process on clipboard write failure (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9713",
              children: "#9713"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(filewatcher): handle removed directories #8800 (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9406",
              children: "#9406"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix: correct TUI vim binds direction (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9529",
              children: "#9529"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix: packages listed twice in watch mode (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9644",
              children: "#9644"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix: respect output mode 'none' even when caching is disabled (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9670",
              children: "#9670"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix: upgrade the turbo package in Yarn 4 (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/8076",
              children: "#8076"
            }), ")"]
          }), "\n"]
        })
      }), _jsx(Accordion, {
        title: "Documentation (42)",
        children: _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["docs: changesets configuration (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9325",
              children: "#9325"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: clarify output globs relativeness. (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9449",
              children: "#9449"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: add ", _jsx(_components.code, {
              children: "TURBO_CACHE"
            }), " to System Environment Variables. (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9450",
              children: "#9450"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(turbopack): Add incremental-computation page, intended to replace core-concepts page (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9456",
              children: "#9456"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(turbopack): Remove old core-concepts page (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9457",
              children: "#9457"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: small stylistic change for footnote. (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9451",
              children: "#9451"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: improve clarity on ", _jsx(_components.code, {
              children: "--cache"
            }), ". (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9489",
              children: "#9489"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: mark ", _jsx(_components.code, {
              children: "--no-cache"
            }), " and ", _jsx(_components.code, {
              children: "--remote-only"
            }), " as deprecated. (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9488",
              children: "#9488"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: describe using a custom URL with ", _jsx(_components.code, {
              children: "create-turbo"
            }), ". (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9507",
              children: "#9507"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: fix formatting on ", _jsx(_components.code, {
              children: "/docs/getting-started/installation"
            }), " (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9509",
              children: "#9509"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: fix formatting on ", _jsx(_components.code, {
              children: "/docs/getting-started/installation"
            }), " (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9514",
              children: "#9514"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: update ESLint documentation with ESLint v9 (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9515",
              children: "#9515"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: options one-pager (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9533",
              children: "#9533"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(typo): fix typo on turbo-ignore page (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9576",
              children: "#9576"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: clarify default daemon usage (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9566",
              children: "#9566"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: provide reasoning on why Turborepo doesn't support nested workspaces (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9586",
              children: "#9586"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: update CONTRIBUTING.md (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9590",
              children: "#9590"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: change path of options overview page (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9600",
              children: "#9600"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: remove old options page (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9601",
              children: "#9601"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: add community implementations of Remote Cache (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9631",
              children: "#9631"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: fix CONTRIBUTING.md typo (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9637",
              children: "#9637"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: mention capnp in the dependencies (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9643",
              children: "#9643"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: add missing ", _jsx(_components.code, {
              children: "api"
            }), " folder in ", _jsx(_components.code, {
              children: "turbo prune api --docker"
            }), " example (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9648",
              children: "#9648"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: add missing ", _jsx(_components.code, {
              children: "apps"
            }), " folder in ", _jsx(_components.code, {
              children: "prune"
            }), " command reference (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9658",
              children: "#9658"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: correct Bun support status (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9664",
              children: "#9664"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: mention module resolution differences for package managers (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9665",
              children: "#9665"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(errors): improve error message for recursive calls (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9650",
              children: "#9650"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: guide for Playwright (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9662",
              children: "#9662"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: mention --graph on graphs page (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9661",
              children: "#9661"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: document creating packages with framework bindings (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9222",
              children: "#9222"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: add note about packaging patterns (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9673",
              children: "#9673"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: guide for shadcn/ui (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9675",
              children: "#9675"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: add link to shadcn/ui page (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9678",
              children: "#9678"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: mention free remote caching earlier on page (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9688",
              children: "#9688"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: typo fix (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9690",
              children: "#9690"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(fix): correct line highlighting by removing extra comma (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9696",
              children: "#9696"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: add community-built Run Summaries web viewer (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9679",
              children: "#9679"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: edits for Prisma guide (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9682",
              children: "#9682"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: update docs to use correct changeset dir (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9722",
              children: "#9722"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: update CONTRIBUTING.md (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9759",
              children: "#9759"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: migration guide for users coming from Nx (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9762",
              children: "#9762"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: fix typo (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9814",
              children: "#9814"
            }), ")"]
          }), "\n"]
        })
      })]
    }), "\n", _jsx(_components.h2, {
      id: "acknowledgments-and-community",
      children: "Acknowledgments and community"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo is the result of the combined work of all of its contributors, including our core team: ", _jsx(_components.a, {
        href: "https://github.com/anthonyshew",
        children: "Anthony"
      }), ", ", _jsx(_components.a, {
        href: "https://github.com/chris-olszewski",
        children: "Chris"
      }), ", ", _jsx(_components.a, {
        href: "https://github.com/dimitropoulos",
        children: "Dimitri"
      }), ", ", _jsx(_components.a, {
        href: "https://github.com/NicholasLYang",
        children: "Nicholas"
      }), ", and ", _jsx(_components.a, {
        href: "https://github.com/tknickman",
        children: "Tom"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Thank you for your continued support, feedback, and collaboration to make Turborepo your build tool of choice. To learn how to get involved, ", _jsx(_components.a, {
        href: "/docs/community",
        children: "visit the Community page"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "We also thank everyone who contributed to this release of Turborepo: @aaronccasanova, @AlvaroParker, @ankur-arch, @arosequist, @atimmer, @bgw, @bitttttten, @chaficnajjar, @codexshell, @eps1lon, @gianelli99, @glitched-w0rld, @JasonnnW3000, @jbrocksfellas, @jeremy-code, @jonathandsouza, @Juneezee, @kayumuzzaman, @krlvi, @maciej-ka, @ognevny, @olets, @pkerschbaum, @romanofski, @shivam-pawar, @takaebato, @tevem1207, @thebrubaker, @Tofandel, @trivikr, @yamz8, and @zsh77."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
